import React, { useState, useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Search } from 'carbon-components-react';
import Util from 'utilities/helper.util';
import { MapGetPlaceSuggestPayload } from 'types';
import { getPlaceSuggestStart, clearPlaceSuggest } from 'redux/map/actions';

const AddressSearch: React.FC<Props> = ({
  showHideBox,
  currentScope,
  placeholder,
  noOpenButton,
  searchResult
}) => {
  const dispatch = useDispatch();

  const [searchInputValue, setSearchInputValue] = useState<string>('');

  // Ref: https://www.freecodecamp.org/news/debounce-and-throttle-in-react-with-hooks/
  const debouncedFunction = useCallback(
    Util.debounce(async (args: string[]) => {
      if (!window?.loadedView?.center) {
        return;
      }
      const value = args[0];
      if (value.length < 3) {
        return;
      }
      const payload: MapGetPlaceSuggestPayload = {
        datasets: currentScope,
        query: value,
        fields: 'region,locality',
        limit: '5',
        location: `${window.loadedView.center.longitude},${window.loadedView.center.latitude}`
      };
      dispatch(getPlaceSuggestStart(payload));
    }, 350),
    [currentScope]
  );

  const handleInputChange = (value: string) => {
    if (value) {
      debouncedFunction(value);
    } else {
      dispatch(clearPlaceSuggest());
    }
    setSearchInputValue(value);
  };

  useEffect(() => {
    setSearchInputValue(searchResult || '');
  }, [searchResult]);

  return (
    <div className="mls-control-container">
      <Search
        id="mls-input"
        labelText=""
        size="sm"
        value={searchInputValue}
        placeHolderText={placeholder}
        onFocus={showHideBox}
        onChange={(evt) => handleInputChange(evt.target.value)}
        className={`${!noOpenButton ? 'bx--search-open-button' : ''}`}
      />
    </div>
  );
};

const propTypes = {
  showHideBox: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
  noOpenButton: PropTypes.bool,
  currentScope: PropTypes.string.isRequired,
  searchResult: PropTypes.string
};

type Props = PropTypes.InferProps<typeof propTypes>;

AddressSearch.defaultProps = {
  noOpenButton: false,
  placeholder: ''
};

export default AddressSearch;
